<script setup lang="ts">
import { onMounted, onBeforeUnmount, ref, useTemplateRef } from 'vue';
import { Creator, ErrorCorrectionLevel, Renderer } from 'easy-qrcode';

const props = defineProps<{
    url: string;
}>();

const matrix = ref();
const qrcode = useTemplateRef('qrcode');

onMounted(() => {
    const qrCreator = new Creator({
        errorCorrectionLevel: ErrorCorrectionLevel.M,
    });
    qrCreator.add(props.url);
    qrCreator.create();
    matrix.value = qrCreator.getMatrix();

    const qrRenderer = new Renderer();
    const canvas = qrRenderer.drawCanvas(matrix.value);

    if (qrcode.value) {
        qrcode.value.append(canvas);
    }
});

onBeforeUnmount(() => {
    if (qrcode.value) {
        qrcode.value.innerHTML = '';
    }
    matrix.value = null;
});
</script>

<template>
    <div data-testid="qr-code" ref="qrcode"></div>
</template>
